import * as yup from 'yup';
import { profile as TEXT } from 'locales/en';

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const FIELD_NAMES = {
  first_name: 'first_name',
  last_name: 'last_name',
  email: 'email',
  phone: 'phone',
  password: 'password',
};

const schema = yup.object().shape({
  [FIELD_NAMES.first_name]: yup.string(),
  [FIELD_NAMES.last_name]: yup.string(),
  [FIELD_NAMES.email]: yup.string().email(TEXT.errors.email.invalid),
  [FIELD_NAMES.phone]: yup
    .string()
    .matches(phoneRegExp, TEXT.errors.phone.invalid),
  [FIELD_NAMES.password]: yup
    .string()
    .matches(/^(|.{8,})$/, TEXT.errors.password.min),
});

export default schema;
